import { ReactElement, useState, useEffect, useContext } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { history } from 'umi';
import { useDispatch } from 'dva';
import { Col, Row, Statistic, Divider } from 'antd';
import { Typography, Button, Modal, message } from 'iglooform';
import './quote-detail.less';
import Context from '@/utils/context';
import { StatusBox } from 'iglooform';
import { images } from '@/assets/images';
import { QuotationStatusType, QuotationStatus } from '@/utils/status';
import DynamicItem from '../dynamic-item';
import moment from 'moment';
import addOnIdToName from '@/pages/common/addon-id-to-name';
import { getImageUrl, CreateShare } from '@/service';
import {
  BSHHospitalCashProductKey,
  BSHPAProductKey,
} from '@/constants/productKey';

const currentLang = localStorage.getItem('selected_lang');

const TurboConfigDetail = (value: any) => {
  const { elements, detailConfig, label } = value;
  const { formatMessage: originalFormatMessage } = useIntl();
  const { isPc } = useContext(Context);
  const [vehicleImage, setVehicleImage] = useState<any[]>();

  const formatMessage = ({ id }: { id: string | undefined }) => {
    return id ? originalFormatMessage({ id }) : '';
  };

  useEffect(() => {
    let chassisImage = new Promise(async (resolve, reject) => {
      if (detailConfig?.chassis_or_engine_image?.length > 0) {
        if (detailConfig?.chassis_or_engine_image[0]?.includes(API_URL)) {
          const res = await getImageUrl(
            detailConfig?.chassis_or_engine_image[0],
          );
          resolve({
            name: 'chassis_or_engine_image',
            url: res.url,
          });
        } else {
          resolve({
            name: 'chassis_or_engine_image',
            url: detailConfig?.chassis_or_engine_image[0],
          });
        }
      }
    });
    let vehicleFront = new Promise(async (resolve, reject) => {
      if (detailConfig?.vehicle_front?.length > 0) {
        if (detailConfig?.vehicle_front[0]?.includes(API_URL)) {
          const res = await getImageUrl(detailConfig?.vehicle_front[0]);
          resolve({
            name: 'vehicle_front',
            url: res.url,
          });
        } else {
          resolve({
            name: 'vehicle_front',
            url: detailConfig?.vehicle_front[0],
          });
        }
      }
    });
    let vehicleLeft = new Promise(async (resolve, reject) => {
      if (detailConfig?.vehicle_left?.length > 0) {
        if (detailConfig?.vehicle_left[0]?.includes(API_URL)) {
          const res = await getImageUrl(detailConfig?.vehicle_left[0]);
          resolve({
            name: 'vehicle_left',
            url: res.url,
          });
        } else {
          resolve({
            name: 'vehicle_left',
            url: detailConfig?.vehicle_left[0],
          });
        }
      }
    });
    let vehicleRear = new Promise(async (resolve, reject) => {
      if (detailConfig?.vehicle_rear?.length > 0) {
        if (detailConfig?.vehicle_rear[0]?.includes(API_URL)) {
          const res = await getImageUrl(detailConfig?.vehicle_rear[0]);
          resolve({
            name: 'vehicle_rear',
            url: res.url,
          });
        } else {
          resolve({
            name: 'vehicle_rear',
            url: detailConfig?.vehicle_rear[0],
          });
        }
      }
    });
    let vehicleRight = new Promise(async (resolve, reject) => {
      if (detailConfig?.vehicle_right?.length > 0) {
        if (detailConfig?.vehicle_right[0]?.includes(API_URL)) {
          const res = await getImageUrl(detailConfig?.vehicle_right[0]);
          resolve({
            name: 'vehicle_right',
            url: res.url,
          });
        } else {
          resolve({
            name: 'vehicle_right',
            url: detailConfig?.vehicle_right[0],
          });
        }
      }
    });
    let vinImage = new Promise(async (resolve, reject) => {
      if (detailConfig?.vin_image?.length > 0) {
        if (detailConfig?.vin_image[0]?.includes(API_URL)) {
          const res = await getImageUrl(detailConfig?.vin_image[0]);
          resolve({
            name: 'vin_image',
            url: res.url,
          });
        } else {
          resolve({
            name: 'vin_image',
            url: detailConfig?.vin_image[0],
          });
        }
      }
    });

    if (detailConfig?.vin_image?.length > 0) {
      Promise.all([
        vehicleFront,
        vehicleLeft,
        vehicleRear,
        vehicleRight,
        vinImage,
      ]).then((result) => {
        setVehicleImage(result);
      });
    } else {
      Promise.all([
        chassisImage,
        vehicleFront,
        vehicleLeft,
        vehicleRear,
        vehicleRight,
      ]).then((result) => {
        setVehicleImage(result);
      });
    }
  }, []);

  const vehicleName = [
    'vehicle_front',
    'vehicle_rear',
    'vehicle_left',
    'vehicle_right',
    'chassis_or_engine_image',
    'vin_image',
  ];

  if (!isPc) {
    return (
      <div>
        <div style={{ marginBottom: 8 }}>
          <Typography
            level="h4"
            style={{ display: 'block', marginBottom: '12px' }}
            wrapElement="div"
          >
            {formatMessage({ id: label })}
          </Typography>
        </div>
        {elements &&
          elements.length > 0 &&
          elements.map((value: any, index: number) => {
            if (value.type === 'Typography') {
              return;
            }
            if (!detailConfig[value.name]) return;
            if (vehicleName.indexOf(value.name) >= 0 && vehicleImage) {
              let component: any;
              vehicleImage?.map((val: any) => {
                if (val.name === value.name) {
                  component = (
                    <div style={{ marginBottom: 8 }}>
                      <Typography
                        level="body2"
                        className="title"
                        wrapElement="div"
                      >
                        {formatMessage({ id: value.label })}
                      </Typography>
                      <Typography level="body2">
                        <a onClick={() => window.open(val.url)}>
                          {formatMessage({ id: 'View' })}
                        </a>
                      </Typography>
                    </div>
                  );
                }
              });

              return component;
            }
            if (value.type === 'PhoneNumber') {
              const v = detailConfig[value.name];
              if (!v.phoneNumber) {
                return null;
              }
              return (
                <div style={{ marginBottom: 8 }} key={index}>
                  <Typography level="body2" className="title" wrapElement="div">
                    {formatMessage({ id: value.label })}
                  </Typography>
                  <Typography level="body2">
                    {value.areaCode} {v.phoneNumber}
                  </Typography>
                </div>
              );
            }
            if (value.options) {
              const v = detailConfig[value.name];
              const displayValue = value.options.find(
                (option: any) => option.value === v,
              )?.label;
              return (
                <div style={{ marginBottom: 8 }} key={index}>
                  <Typography level="body2" className="title" wrapElement="div">
                    {formatMessage({ id: value.label })}
                  </Typography>
                  <Typography level="body2">
                    {formatMessage({ id: displayValue })}
                  </Typography>
                </div>
              );
            }
            if (value.type === 'DatePicker') {
              return (
                <div style={{ marginBottom: 8 }} key={index}>
                  <Typography level="body2" className="title" wrapElement="div">
                    {formatMessage({ id: value.label })}
                  </Typography>
                  <Typography level="body2">
                    {moment(detailConfig[value.name]).format('DD / MM / YYYY')}
                  </Typography>
                </div>
              );
            }
            if (value.type === 'Select' && value.datasourceKey) {
              return (
                <DynamicItem
                  config={value}
                  formValue={detailConfig}
                  isPc={false}
                  key={index}
                />
              );
            }
            if (value.type === 'AddableSection') {
              const arrVal = detailConfig[value.name];
              return arrVal.map((item: Record<string, any>, idx: number) => {
                return (
                  <>
                    <Typography level="h4" className="addableSubTitle">
                      {formatMessage({ id: value.label })} {idx + 1}
                    </Typography>
                    {value.elements.map((ele: any, idx: number) => {
                      if (!item[ele?.name]) return;
                      if (ele.options) {
                        const v = item[ele?.name];
                        const displayValue = ele.options.find(
                          (option: any) => option.value === v,
                        )?.label;
                        return (
                          <div style={{ marginBottom: 8 }} key={idx}>
                            <Typography
                              level="body1"
                              className="title"
                              wrapElement="div"
                            >
                              {formatMessage({ id: ele.label })}
                            </Typography>
                            <Typography level="body1">
                              {formatMessage({ id: displayValue })}
                            </Typography>
                          </div>
                        );
                      }
                      if (ele.type === 'PhoneNumber') {
                        const v = item[ele?.name];
                        if (!v.phoneNumber) {
                          return null;
                        }
                        return (
                          <div style={{ marginBottom: 8 }} key={idx}>
                            <Typography
                              level="body1"
                              className="title"
                              wrapElement="div"
                            >
                              {formatMessage({ id: ele.label })}
                            </Typography>
                            <Typography level="body1">
                              {ele.areaCode} {v.phoneNumber}
                            </Typography>
                          </div>
                        );
                      }
                      if (ele.type === 'DatePicker') {
                        return (
                          <div style={{ marginBottom: 8 }} key={idx}>
                            <Typography
                              level="body1"
                              className="title"
                              wrapElement="div"
                            >
                              {formatMessage({ id: ele.label })}
                            </Typography>
                            <Typography level="body1">
                              {moment(item[ele?.name]).format('DD / MM / YYYY')}
                            </Typography>
                          </div>
                        );
                      }
                      if (ele.type === 'Select' && ele.datasourceKey) {
                        return (
                          <DynamicItem
                            config={ele}
                            formValue={item}
                            isPc={false}
                            key={idx}
                          />
                        );
                      }
                      return (
                        <div style={{ marginBottom: 8 }} key={idx}>
                          <Typography
                            level="body1"
                            className="title"
                            wrapElement="div"
                          >
                            {formatMessage({ id: ele.label })}
                          </Typography>
                          <Typography level="body1">
                            {item[ele?.name]}
                          </Typography>
                        </div>
                      );
                    })}
                  </>
                );
              });
            }
            return (
              <div style={{ marginBottom: 8 }} key={index}>
                <Typography level="body2" className="title" wrapElement="div">
                  {formatMessage({ id: value.label })}
                </Typography>
                <Typography level="body2">
                  {detailConfig[value.name]}
                </Typography>
              </div>
            );
          })}
      </div>
    );
  }

  return (
    <Row
      gutter={[16, 0]}
      className="detailBottomBox"
      style={{ paddingTop: '0', paddingBottom: '0' }}
    >
      <Col span={24}>
        <Typography
          level="h4"
          style={{ display: 'block', marginBottom: '16px' }}
        >
          {formatMessage({ id: label })}
        </Typography>
      </Col>
      {elements &&
        elements.length > 0 &&
        elements.map((value: any, index: number) => {
          if (value.type === 'Typography') {
            return;
          }
          if (!detailConfig[value.name]) return;
          if (vehicleName.indexOf(value.name) >= 0 && vehicleImage) {
            let component: any;
            vehicleImage?.map((val: any) => {
              if (val.name === value.name) {
                component = (
                  <Col span={6} style={{ marginBottom: '16px' }}>
                    <Typography
                      level="body1"
                      className="title"
                      wrapElement="div"
                    >
                      {formatMessage({ id: value.label })}
                    </Typography>
                    <Typography level="body1">
                      <a onClick={() => window.open(val.url)}>
                        {formatMessage({ id: 'View' })}
                      </a>
                    </Typography>
                  </Col>
                );
              }
            });
            return component;
          }
          if (value.type === 'PhoneNumber') {
            const v = detailConfig[value.name];
            if (!v.phoneNumber) {
              return null;
            }
            return (
              <Col span={6} style={{ marginBottom: '16px' }} key={index}>
                <Typography level="body1" className="title">
                  {formatMessage({ id: value.label })}
                </Typography>
                <Typography level="body1">
                  {value.areaCode} {v.phoneNumber}
                </Typography>
              </Col>
            );
          }
          if (value.options) {
            const v = detailConfig[value.name];
            const displayValue = value.options.find(
              (option: any) => option.value === v,
            )?.label;
            return (
              <Col span={6} style={{ marginBottom: '16px' }} key={index}>
                <Typography level="body1" className="title">
                  {formatMessage({ id: value.label })}
                </Typography>
                <Typography level="body1">
                  {formatMessage({ id: displayValue })}
                </Typography>
              </Col>
            );
          }
          if (value.type === 'DatePicker') {
            return (
              <Col span={6} style={{ marginBottom: '16px' }} key={index}>
                <Typography level="body1" className="title">
                  {formatMessage({ id: value.label })}
                </Typography>
                <Typography level="body1">
                  {moment(detailConfig[value.name]).format('DD / MM / YYYY')}
                </Typography>
              </Col>
            );
          }
          if (value.type === 'Select' && value.datasourceKey) {
            return (
              <DynamicItem
                config={value}
                formValue={detailConfig}
                isPc={true}
                key={index}
              />
            );
          }
          if (value.type === 'AddableSection') {
            const arrVal = detailConfig[value.name];
            return arrVal.map((item: Record<string, any>, idx: number) => {
              return (
                <>
                  <Typography level="h4" className="addableSubTitle">
                    {formatMessage({ id: value.label })} {idx + 1}
                  </Typography>
                  {value.elements.map((ele: any, idx: number) => {
                    if (!item[ele?.name]) return;
                    if (ele.options) {
                      const v = item[ele?.name];
                      const displayValue = ele.options.find(
                        (option: any) => option.value === v,
                      )?.label;
                      return (
                        <Col
                          span={6}
                          style={{ marginBottom: '16px' }}
                          key={idx}
                        >
                          <Typography level="body1" className="title">
                            {formatMessage({ id: ele.label })}
                          </Typography>
                          <Typography level="body1">
                            {formatMessage({ id: displayValue })}
                          </Typography>
                        </Col>
                      );
                    }
                    if (ele.type === 'PhoneNumber') {
                      const v = item[ele?.name];
                      if (!v.phoneNumber) {
                        return null;
                      }
                      return (
                        <Col
                          span={6}
                          style={{ marginBottom: '16px' }}
                          key={idx}
                        >
                          <Typography level="body1" className="title">
                            {formatMessage({ id: ele.label })}
                          </Typography>
                          <Typography level="body1">
                            {ele.areaCode} {v.phoneNumber}
                          </Typography>
                        </Col>
                      );
                    }
                    if (ele.type === 'DatePicker') {
                      return (
                        <Col
                          span={6}
                          style={{ marginBottom: '16px' }}
                          key={idx}
                        >
                          <Typography level="body1" className="title">
                            {formatMessage({ id: ele.label })}
                          </Typography>
                          <Typography level="body1">
                            {moment(item[ele?.name]).format('DD / MM / YYYY')}
                          </Typography>
                        </Col>
                      );
                    }
                    if (ele.type === 'Select' && ele.datasourceKey) {
                      return (
                        <DynamicItem
                          config={ele}
                          formValue={item}
                          isPc={true}
                          key={idx}
                        />
                      );
                    }
                    return (
                      <Col span={6} style={{ marginBottom: '16px' }} key={idx}>
                        <Typography level="body1" className="title">
                          {formatMessage({ id: ele.label })}
                        </Typography>
                        <Typography level="body1">{item[ele?.name]}</Typography>
                      </Col>
                    );
                  })}
                </>
              );
            });
          }
          return (
            <Col span={6} style={{ marginBottom: '16px' }} key={index}>
              <Typography level="body1" className="title">
                {formatMessage({ id: value.label })}
              </Typography>
              <Typography level="body1">{detailConfig[value.name]}</Typography>
            </Col>
          );
        })}
      <Divider style={{ marginTop: '8px', marginBottom: '24px' }} />
    </Row>
  );
};

const PolicyHolder = (props: any) => {
  const { formatMessage } = useIntl();
  const { quoteDetail } = props;
  const { isPc } = useContext(Context);

  const { fast_quote, product, form } = quoteDetail;

  const isBSHHcOrBSHPa = [BSHHospitalCashProductKey, BSHPAProductKey].includes(
    product?.product_key,
  );

  const keyMap: Record<string, any> = {
    applicants: 'Plan',
    insured_num: 'No. of Insured',
  };

  if (!isPc) {
    return (
      <div style={{ marginTop: '12px' }}>
        <div>
          <Typography
            level="h4"
            style={{ display: 'block', marginBottom: '12px' }}
          >
            {formatMessage({ id: 'Fast Quote' })}
          </Typography>
        </div>
        {Object.entries(fast_quote).map((value: any, index: any) => {
          if (!value[1]) return;
          if (typeof value[1] === 'boolean') return;
          let titleList: any = [];
          value[0].split('_').map((value: any, index: any) => {
            let res;
            if (value === 'travel') return titleList.push('Journey');
            res = value[0].toUpperCase() + value.substr(1);
            titleList.push(res);
          });

          let title: any = '';

          if (keyMap[value[0]]) {
            title = keyMap[value[0]];
          } else {
            let titleList: any = [];
            value[0].split('_').map((value: any) => {
              let res = value[0].toUpperCase() + value.substr(1);
              titleList.push(res);
            });
            title = titleList.join(' ');
          }

          return (
            <div style={{ marginBottom: 8 }} key={index}>
              <Typography level="body2" className="title" wrapElement="div">
                {formatMessage({ id: title })}
              </Typography>
              {value[0]?.includes('date') ? (
                <Typography level="body2">
                  {moment(value[1]).format('DD / MM / YYYY')}
                </Typography>
              ) : (
                <Typography level="body2">{value[1]}</Typography>
              )}
            </div>
          );
        })}
      </div>
    );
  }

  return (
    <Row
      gutter={[16, 0]}
      className="detailBottomBox"
      style={{ paddingTop: '0', paddingBottom: '0' }}
    >
      <Col span={24}>
        <Typography
          level="h4"
          style={{ display: 'block', marginBottom: '16px' }}
        >
          {formatMessage({ id: 'Fast Quote' })}
        </Typography>
      </Col>
      {Object.entries(fast_quote).map((value: any, index: any) => {
        if (!value[1]) return;
        if (typeof value[1] === 'boolean') return;
        let titleList: any = [];
        value[0].split('_').map((value: any, index: any) => {
          let res;
          if (value === 'travel') return titleList.push('Journey');
          res = value[0].toUpperCase() + value.substr(1);
          titleList.push(res);
        });

        let title: any = '';

        if (keyMap[value[0]]) {
          title = keyMap[value[0]];
        } else {
          let titleList: any = [];
          value[0].split('_').map((value: any) => {
            let res = value[0].toUpperCase() + value.substr(1);
            titleList.push(res);
          });
          title = titleList.join(' ');
        }

        if (value[0] === 'vehicle_value') {
          return (
            <Col span={6} style={{ marginBottom: '16px' }} key={index}>
              <Typography level="body1" className="title" wrapElement="div">
                {formatMessage({ id: title })}
              </Typography>
              <Typography level="body1">
                <Statistic
                  style={{ display: 'inline-block' }}
                  value={value[1]}
                  groupSeparator={currentLang === 'vi-VN' ? '.' : ','}
                  decimalSeparator={currentLang === 'vi-VN' ? ',' : '.'}
                />
              </Typography>
            </Col>
          );
        }

        // 有可能增减人过后，fast_quote里面的insured_num与form里不能够对应上
        if (value[0] === 'insured_num' && isBSHHcOrBSHPa && form) {
          return;
        }

        return (
          <Col span={6} style={{ marginBottom: '16px' }} key={index}>
            <Typography level="body1" className="title" wrapElement="div">
              {formatMessage({ id: title })}
            </Typography>
            {value[0]?.includes('date') ? (
              <Typography level="body1">
                {moment(value[1]).format('DD / MM / YYYY')}
              </Typography>
            ) : (
              <Typography level="body1">
                {formatMessage({ id: value[1] })}
              </Typography>
            )}
          </Col>
        );
      })}
      <Divider style={{ marginTop: '8px', marginBottom: '24px' }} />
    </Row>
  );
};

const PremiumModal = (props: any) => {
  const { formatMessage } = useIntl();
  const { visible, setVisible, quoteDetail } = props;
  return (
    <Modal
      visible={visible}
      width={700}
      title={formatMessage({
        id: 'Premium Detail',
      })}
      onCancel={() => setVisible(false)}
      footer={''}
    >
      <section>
        <Typography
          level="body2"
          style={{ color: '#999', fontStyle: 'italic' }}
        >
          {formatMessage({ id: 'All premiums in Vietnamese Dong' })}
        </Typography>
        {!quoteDetail?.product?.name.includes('BSH Domestic travel') && (
          <section
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginTop: '16px',
            }}
          >
            <Typography level="body1">
              {formatMessage({ id: 'Base Premium' })}
            </Typography>
            <Statistic
              style={{ display: 'inline-block' }}
              value={
                quoteDetail?.meta?.without_tax_premium ||
                quoteDetail?.meta?.base_premium
              }
              groupSeparator={currentLang === 'vi-VN' ? '.' : ','}
              decimalSeparator={currentLang === 'vi-VN' ? ',' : '.'}
            />
          </section>
        )}
        {quoteDetail.meta?.premium_info?.add_ons && (
          <div>
            <section
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginTop: '16px',
              }}
            >
              <Typography level="body1">
                {formatMessage({ id: 'Add-Ons Benefits' })}
              </Typography>
              <Statistic
                style={{ display: 'inline-block' }}
                value={quoteDetail.meta?.premium_info?.add_ons?.total_premium}
                groupSeparator={currentLang === 'vi-VN' ? '.' : ','}
                decimalSeparator={currentLang === 'vi-VN' ? ',' : '.'}
              />
            </section>

            {quoteDetail.meta?.premium_info?.add_ons?.add_ons.map(
              (value: any, index: any) => {
                if (!value.enable) return;
                return (
                  <section
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      marginTop: '8px',
                      marginLeft: '8px',
                      color: '#999',
                    }}
                  >
                    <Typography level="body2">
                      <FormattedMessage {...addOnIdToName[value.add_on_id]} />
                    </Typography>
                    <Statistic
                      style={{ display: 'inline-block' }}
                      value={value.premium}
                      groupSeparator={currentLang === 'vi-VN' ? '.' : ','}
                      decimalSeparator={currentLang === 'vi-VN' ? ',' : '.'}
                      valueStyle={{ color: '#999', fontSize: '14px' }}
                    />
                  </section>
                );
              },
            )}
          </div>
        )}

        {quoteDetail?.meta?.pa_premium && (
          <section
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginTop: '16px',
            }}
          >
            <Typography level="body1">
              {formatMessage({ id: 'Add-ons Sub-total' })}
            </Typography>
            <Statistic
              style={{ display: 'inline-block' }}
              value={quoteDetail?.meta?.pa_premium}
              groupSeparator={currentLang === 'vi-VN' ? '.' : ','}
              decimalSeparator={currentLang === 'vi-VN' ? ',' : '.'}
            />
          </section>
        )}
        {quoteDetail?.meta?.family_unit && (
          <section
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginTop: '16px',
            }}
          >
            <Typography level="body1">
              {formatMessage({ id: 'Premium/Person/Day' })}
            </Typography>
            <Statistic
              style={{ display: 'inline-block' }}
              value={quoteDetail?.meta?.family_unit}
              groupSeparator={currentLang === 'vi-VN' ? '.' : ','}
              decimalSeparator={currentLang === 'vi-VN' ? ',' : '.'}
            />
          </section>
        )}
        {quoteDetail?.fast_quote?.traveller_type === 'Individual' && (
          <section
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginTop: '16px',
            }}
          >
            <Typography level="body1">
              {formatMessage({ id: 'No. of Insured' })}
            </Typography>
            <Statistic
              style={{ display: 'inline-block' }}
              value={quoteDetail?.fast_quote?.insured_num}
              groupSeparator={currentLang === 'vi-VN' ? '.' : ','}
              decimalSeparator={currentLang === 'vi-VN' ? ',' : '.'}
            />
          </section>
        )}
        {quoteDetail?.meta?.travel_days && (
          <section
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginTop: '16px',
            }}
          >
            <Typography level="body1">
              {formatMessage({ id: 'No. of Days' })}
            </Typography>
            <Statistic
              style={{ display: 'inline-block' }}
              value={quoteDetail?.meta?.travel_days}
              groupSeparator={currentLang === 'vi-VN' ? '.' : ','}
              decimalSeparator={currentLang === 'vi-VN' ? ',' : '.'}
            />
          </section>
        )}
        {quoteDetail?.meta?.pa_premium > 0 && (
          <section
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginTop: '8px',
              marginLeft: '8px',
              color: '#999',
            }}
          >
            <Typography level="body2">
              {formatMessage({ id: 'Personal Accident' })}
            </Typography>
            <Statistic
              style={{ display: 'inline-block' }}
              value={quoteDetail.meta?.pa_premium}
              groupSeparator={currentLang === 'vi-VN' ? '.' : ','}
              decimalSeparator={currentLang === 'vi-VN' ? ',' : '.'}
            />
          </section>
        )}
        {quoteDetail?.meta?.PlanPremiumAmount > 0 &&
          !quoteDetail?.product?.name.includes('BSH Domestic travel') && (
            <section
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginTop: '16px',
              }}
            >
              <Typography level="body1">
                {formatMessage({
                  id: 'Total Gross Premium',
                })}
              </Typography>
              <Statistic
                style={{ display: 'inline-block' }}
                value={
                  quoteDetail?.meta?.vat
                    ? quoteDetail?.meta?.PlanPremiumAmount -
                      quoteDetail?.meta?.vat
                    : quoteDetail?.meta?.PlanPremiumAmount
                }
                groupSeparator={currentLang === 'vi-VN' ? '.' : ','}
                decimalSeparator={currentLang === 'vi-VN' ? ',' : '.'}
              />
            </section>
          )}
        {quoteDetail?.meta?.vat > 0 && (
          <section
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginTop: '16px',
            }}
          >
            <Typography level="body1">
              {formatMessage({ id: 'VAT' })}
              {`(${
                quoteDetail?.meta?.without_tax_premium / quoteDetail?.meta?.vat
              })%`}
            </Typography>
            <Statistic
              style={{ display: 'inline-block' }}
              value={quoteDetail?.meta?.vat}
              groupSeparator={currentLang === 'vi-VN' ? '.' : ','}
              decimalSeparator={currentLang === 'vi-VN' ? ',' : '.'}
            />
          </section>
        )}

        {quoteDetail.meta?.admin_free && quoteDetail.meta?.stamp_duty && (
          <section
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginTop: '16px',
            }}
          >
            <Typography level="body1">
              {formatMessage({ id: 'Policy Fee' })}
            </Typography>
            <Statistic
              style={{ display: 'inline-block' }}
              value={
                quoteDetail.meta?.admin_free + quoteDetail.meta?.stamp_duty
              }
              groupSeparator={currentLang === 'vi-VN' ? '.' : ','}
              decimalSeparator={currentLang === 'vi-VN' ? ',' : '.'}
            />
          </section>
        )}
        {quoteDetail?.meta?.stamp_duty && (
          <section
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginTop: '16px',
            }}
          >
            <Typography level="body1">
              {formatMessage({ id: 'Stamp Duty' })}
            </Typography>
            <Statistic
              style={{ display: 'inline-block' }}
              value={quoteDetail.meta?.stamp_duty}
              groupSeparator={currentLang === 'vi-VN' ? '.' : ','}
              decimalSeparator={currentLang === 'vi-VN' ? ',' : '.'}
            />
          </section>
        )}
        <Divider />
        <section style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography level="body1">
            {formatMessage({ id: 'Amount Payable' })}
          </Typography>
          <Statistic
            style={{
              display: 'inline-block',
              fontSize: '24px',
              fontWeight: '500',
            }}
            value={quoteDetail?.meta?.PlanPremiumAmount}
            prefix={formatMessage({ id: 'VND' })}
            groupSeparator={currentLang === 'vi-VN' ? '.' : ','}
            decimalSeparator={currentLang === 'vi-VN' ? ',' : '.'}
            valueStyle={{ color: '#5858ff' }}
          />
        </section>
      </section>
    </Modal>
  );
};

const QuoteDetail = (props: any): ReactElement => {
  const { quoteDetail, quoteDetailConfig, userInfo } = props;
  const dispatch = useDispatch();
  const [url, setUrl] = useState<string>('');
  const { formatMessage } = useIntl();
  const [visible, setVisible] = useState<boolean>(false);
  const { isPc } = useContext(Context);
  const [shareId, setShareId] = useState<any>();
  const [shareUrl, setShareUrl] = useState<any>();

  const handleGetShareUrl = (value: any) => {
    CreateShare(
      value.productType,
      value.productKey,
      value.planKey,
      value.quotationId,
    ).then((res) => {
      setShareUrl(res.url);
      setShareId(res.share_id);
    });
  };

  const goToHome = () => {
    dispatch({
      type: 'global/setData',
      payload: {
        menuKey: 'home',
      },
    });
  };
  const { elements } = quoteDetailConfig?.form?.default;

  const paymentExpiredConfirm = (value: any) => {
    const startDate: any =
      value?.meta?.start || value?.form?.policy?.policy_start_date;
    if (moment().startOf('day').format('x') < startDate) {
      history.push({
        pathname: `/home/${quoteDetail.product.product_type}/payment`,
        query: {
          applicationId: quoteDetail?.application_id,
          productKey: quoteDetail?.product?.product_key,
          planKey: quoteDetail?.plan?.plan_key,
          quotationId: quoteDetail?.shaft_id,
          policyStartDate: startDate,
          rePay: 'true',
        },
      });
      goToHome();
      return;
    }
    Modal.confirm({
      title: formatMessage({ id: 'Start Date Expired' }),
      width: 600,
      closable: true,
      maskClosable: false,
      visible: true,
      content: (
        <Typography level="body1">
          {formatMessage({
            id: 'The policy start date is expired, the system will automatically modify your start date to today and the end date will extend respectively.',
          })}
        </Typography>
      ),
      okText: 'Got it',
      cancelText: 'No',
      onOk: () => {
        history.replace({
          pathname: `/home/${quoteDetail.product.product_type}/payment`,
          query: {
            applicationId: quoteDetail?.application_id,
            productKey: quoteDetail?.product?.product_key,
            planKey: quoteDetail?.plan?.plan_key,
            quotationId: quoteDetail?.shaft_id,
            policyStartDate: startDate,
          },
        });
        goToHome();
      },
    });
  };
  useEffect(() => {
    if (
      quoteDetail?.product?.logo_url &&
      quoteDetail?.product?.logo_url?.includes(API_URL)
    ) {
      getImageUrl(quoteDetail?.product?.logo_url).then((res) => {
        setUrl(res?.url);
      });
    }
    setUrl(quoteDetail?.product?.logo_url);
  }, []);

  useEffect(() => {
    if (!quoteDetail || quoteDetail?.state === 'QuoteExpired') return;
    const value = {
      productType: quoteDetail?.product?.product_type,
      productKey: quoteDetail?.product?.product_key,
      planKey: quoteDetail?.plan?.plan_key,
      quotationId: quoteDetail?.shaft_id,
    };
    handleGetShareUrl(value);
  }, [quoteDetail]);

  if (!isPc) {
    return (
      <>
        <div className="quoteDetailBox-h5">
          <div className="detailTopBox-h5">
            {url && (
              <img src={url || images.tob_icon} alt="" className="icon" />
            )}
            <div className="rightDetail">
              <Typography
                level="h4"
                className="product"
                wrapElement="div"
                style={{ marginBottom: 8 }}
              >
                {quoteDetail?.plan?.name}
              </Typography>
              <div style={{ marginBottom: 8 }}>
                <StatusBox
                  type={QuotationStatusType[quoteDetail?.state]}
                  className="state"
                >
                  <FormattedMessage {...QuotationStatus[quoteDetail?.state]} />
                </StatusBox>
              </div>
              {quoteDetail.state === 'QuoteCreated' &&
                !quoteDetail.product.name.includes('BSH Domestic travel') && (
                  <Button
                    type="primary"
                    onClick={() => {
                      if (userInfo?.status === 2) {
                        message.error(
                          formatMessage({
                            id: 'Your account has been deactivated, please contact your upline manager who you worked.',
                          }),
                        );
                        return;
                      }
                      history.push({
                        pathname: `/home/${quoteDetail?.product?.product_type}/single-quote`,
                        query: {
                          productKey: quoteDetail?.product?.product_key,
                          planKey: quoteDetail?.plan?.plan_key,
                          quotationId: quoteDetail?.shaft_id,
                          applicationId: quoteDetail?.shaft_id,
                        },
                      });
                      goToHome();

                      // event tracking: confirm quote
                      window.gtag('event', 'confirm_quote', {
                        quote_id: quoteDetail?.shaft_id,
                        product_key: quoteDetail?.product?.product_key,
                        plan_key: quoteDetail?.plan?.plan_key,
                        user_unique_id: JSON.parse(
                          localStorage.getItem('user_info') ?? '{}',
                        )?.id,
                      });
                    }}
                    className="button"
                  >
                    {formatMessage({ id: 'Confirm Quote' })}
                  </Button>
                )}
              {quoteDetail.state === 'QuotePreSubmitted' &&
                !quoteDetail.product.name.includes('BSH Domestic travel') && (
                  <Button
                    type="primary"
                    onClick={() => {
                      if (userInfo?.status === 2) {
                        message.error(
                          formatMessage({
                            id: 'Your account has been deactivated, please contact your upline manager who you worked.',
                          }),
                        );
                        return;
                      }
                      history.push({
                        pathname: `/home/${quoteDetail?.product?.product_type}/application`,
                        query: {
                          productKey: quoteDetail?.product?.product_key,
                          planKey: quoteDetail?.plan?.plan_key,
                          quotationId: quoteDetail?.shaft_id,
                          applicationId: quoteDetail?.shaft_id,
                        },
                      });
                      goToHome();

                      // event tracking: re-complete_application
                      window.gtag('event', 're_complete_application', {
                        quote_id: quoteDetail?.shaft_id,
                        product_key: quoteDetail?.product?.product_key,
                        plan_key: quoteDetail?.plan?.plan_key,
                        user_unique_id: JSON.parse(
                          localStorage.getItem('user_info') ?? '{}',
                        )?.id,
                      });
                    }}
                    className="button"
                  >
                    {formatMessage({ id: 'Complete Application' })}
                  </Button>
                )}
              {(quoteDetail.state === 'QuotePaymentPending' ||
                quoteDetail.state === 'QuotePaymentFailed') &&
                !quoteDetail.product.name.includes('BSH Domestic travel') && (
                  <Button
                    type="primary"
                    onClick={() => {
                      if (userInfo?.status === 2) {
                        message.error(
                          formatMessage({
                            id: 'Your account has been deactivated, please contact your upline manager who you worked.',
                          }),
                        );
                        return;
                      }
                      paymentExpiredConfirm(quoteDetail);
                    }}
                    className="button"
                  >
                    {formatMessage({ id: 'Make Payment' })}
                  </Button>
                )}
              {quoteDetail.state !== 'QuoteExpired' &&
                !quoteDetail.product.name.includes('BSH Domestic travel') && (
                  <Button
                    style={{ marginLeft: '16px' }}
                    onClick={() => {
                      history.push({
                        pathname: `/home/${quoteDetail.product.product_type}/share`,
                        query: {
                          share_id: shareId,
                          share_url: shareUrl,
                        },
                      });
                      goToHome();
                    }}
                    className="button"
                  >
                    {formatMessage({ id: 'Share' })}
                  </Button>
                )}
            </div>
          </div>
          <Divider style={{ marginTop: '8px', marginBottom: '8px' }} />
          <Typography level="h4" wrapElement="div" style={{ marginBottom: 12 }}>
            {formatMessage({ id: 'Quote Information' })}
          </Typography>
          <div className="item">
            <Typography level="body2" className="title" wrapElement="div">
              {formatMessage({ id: 'Quote ID' })}
            </Typography>
            <Typography level="body2">{quoteDetail.display_id}</Typography>
          </div>
          {quoteDetail?.meta && (
            <div style={{ marginBottom: '16px' }} className="item">
              <Typography level="body2" className="title" wrapElement="div">
                {formatMessage({ id: 'Premium' })}
              </Typography>
              <Statistic
                style={{ display: 'inline-block' }}
                value={
                  quoteDetail?.meta?.PlanPremiumAmount +
                  (quoteDetail?.meta?.vat || 0)
                }
                prefix={formatMessage({ id: 'VND' })}
                groupSeparator={currentLang === 'vi-VN' ? '.' : ','}
                decimalSeparator={currentLang === 'vi-VN' ? ',' : '.'}
              />
              <a onClick={() => setVisible(true)} style={{ marginLeft: '4px' }}>
                {formatMessage({ id: 'View' })}
              </a>
            </div>
          )}
          <div className="item">
            <Typography level="body2" className="title" wrapElement="div">
              {formatMessage({ id: 'Expire Date' })}
            </Typography>
            <Typography level="body2">
              {moment(quoteDetail?.expire_at * 1000).format('DD / MM / YYYY')}
            </Typography>
          </div>
          {elements &&
            elements.length > 0 &&
            quoteDetail?.form &&
            elements.map((value: any, idx: number) => {
              return (
                <TurboConfigDetail
                  key={idx}
                  elements={value.elements}
                  detailConfig={quoteDetail?.form[value.name]}
                  label={value.label}
                />
              );
            })}
          {quoteDetail?.fast_quote && (
            <PolicyHolder quoteDetail={quoteDetail} />
          )}
        </div>

        <PremiumModal
          visible={visible}
          setVisible={setVisible}
          quoteDetail={quoteDetail}
        />
      </>
    );
  }

  return (
    <>
      <div className="quoteDetailBox">
        <div className="detailTopBox">
          {url && <img src={url || images.tob_icon} alt="" className="icon" />}
          <Typography level="h4" className="product">
            {quoteDetail?.plan?.name}
          </Typography>
          <StatusBox
            type={QuotationStatusType[quoteDetail?.state]}
            className="state"
          >
            <FormattedMessage {...QuotationStatus[quoteDetail?.state]} />
          </StatusBox>
          {quoteDetail.state === 'QuoteCreated' &&
            !quoteDetail.product.name.includes('BSH Domestic travel') && (
              <Button
                style={{ marginLeft: '16px' }}
                type="primary"
                onClick={() => {
                  if (userInfo?.status === 2) {
                    message.error(
                      formatMessage({
                        id: 'Your account has been deactivated, please contact your upline manager who you worked.',
                      }),
                    );
                    return;
                  }
                  history.push({
                    pathname: `/home/${quoteDetail?.product?.product_type}/single-quote`,
                    query: {
                      productKey: quoteDetail?.product?.product_key,
                      planKey: quoteDetail?.plan?.plan_key,
                      quotationId: quoteDetail?.shaft_id,
                      applicationId: quoteDetail?.shaft_id,
                    },
                  });
                  goToHome();

                  // event tracking: confirm quote
                  window.gtag('event', 'confirm_quote', {
                    quote_id: quoteDetail?.shaft_id,
                    product_key: quoteDetail?.product?.product_key,
                    plan_key: quoteDetail?.plan?.plan_key,
                    user_unique_id: JSON.parse(
                      localStorage.getItem('user_info') ?? '{}',
                    )?.id,
                  });
                }}
                className="button"
              >
                {formatMessage({ id: 'Confirm Quote' })}
              </Button>
            )}
          {quoteDetail.state === 'QuotePreSubmitted' &&
            !quoteDetail.product.name.includes('BSH Domestic travel') && (
              <Button
                style={{ marginLeft: '16px' }}
                type="primary"
                onClick={() => {
                  if (userInfo?.status === 2) {
                    message.error(
                      formatMessage({
                        id: 'Your account has been deactivated, please contact your upline manager who you worked.',
                      }),
                    );
                    return;
                  }
                  history.push({
                    pathname: `/home/${quoteDetail?.product?.product_type}/application`,
                    query: {
                      productKey: quoteDetail?.product?.product_key,
                      planKey: quoteDetail?.plan?.plan_key,
                      quotationId: quoteDetail?.shaft_id,
                      applicationId: quoteDetail?.shaft_id,
                    },
                  });
                  goToHome();

                  // event tracking: re-complete_application
                  window.gtag('event', 're_complete_application', {
                    quote_id: quoteDetail?.shaft_id,
                    product_key: quoteDetail?.product?.product_key,
                    plan_key: quoteDetail?.plan?.plan_key,
                    user_unique_id: JSON.parse(
                      localStorage.getItem('user_info') ?? '{}',
                    )?.id,
                  });
                }}
                className="button"
              >
                {formatMessage({ id: 'Complete Application' })}
              </Button>
            )}

          {(quoteDetail.state === 'QuotePaymentPending' ||
            quoteDetail.state === 'QuotePaymentFailed') &&
            !quoteDetail.product.name.includes('BSH Domestic travel') && (
              <Button
                style={{ marginLeft: '16px' }}
                type="primary"
                onClick={() => {
                  if (userInfo?.status === 2) {
                    message.error(
                      formatMessage({
                        id: 'Your account has been deactivated, please contact your upline manager who you worked.',
                      }),
                    );
                    return;
                  }
                  paymentExpiredConfirm(quoteDetail);
                }}
                className="button"
              >
                {formatMessage({ id: 'Make Payment' })}
              </Button>
            )}
          {quoteDetail.state !== 'QuoteExpired' &&
            !quoteDetail.product.name.includes('BSH Domestic travel') && (
              <Button
                style={{ marginLeft: '16px' }}
                onClick={() => {
                  history.push({
                    pathname: `/home/${quoteDetail.product.product_type}/share`,
                    query: {
                      share_id: shareId,
                      share_url: shareUrl,
                    },
                  });
                  goToHome();
                }}
                className="button"
              >
                {formatMessage({ id: 'Share' })}
              </Button>
            )}
        </div>
        <Row
          className="detailBottomBox"
          gutter={[16, 0]}
          style={{ paddingBottom: '0' }}
        >
          <Col span={6} style={{ marginBottom: '16px' }}>
            <Typography level="body1" className="title">
              {formatMessage({ id: 'Quote ID' })}
            </Typography>
            <Typography level="body1">{quoteDetail.display_id}</Typography>
          </Col>
          {quoteDetail?.meta && (
            <Col span={6} style={{ marginBottom: '16px' }}>
              <Typography level="body1" className="title">
                {formatMessage({ id: 'Premium' })}
              </Typography>
              <Statistic
                style={{ display: 'inline-block' }}
                value={quoteDetail?.meta?.PlanPremiumAmount}
                prefix={formatMessage({ id: 'VND' })}
                groupSeparator={currentLang === 'vi-VN' ? '.' : ','}
                decimalSeparator={currentLang === 'vi-VN' ? ',' : '.'}
              />
              <a onClick={() => setVisible(true)} style={{ marginLeft: '4px' }}>
                {formatMessage({ id: 'View' })}
              </a>
            </Col>
          )}
          <Col span={6} style={{ marginBottom: '16px' }}>
            <Typography level="body1" className="title" wrapElement="div">
              {formatMessage({ id: 'Expire Date' })}
            </Typography>
            <Typography level="body1">
              {moment(quoteDetail?.expire_at * 1000).format('DD / MM / YYYY')}
            </Typography>
          </Col>
          <Divider style={{ marginTop: '8px', marginBottom: '24px' }} />
        </Row>
        {elements &&
          elements.length > 0 &&
          quoteDetail?.form &&
          elements.map((value: any, idx: number) => {
            return (
              <TurboConfigDetail
                key={idx}
                elements={value.elements}
                detailConfig={quoteDetail?.form[value.name]}
                label={value.label}
              />
            );
          })}
        {quoteDetail?.fast_quote && <PolicyHolder quoteDetail={quoteDetail} />}
      </div>
      <PremiumModal
        visible={visible}
        setVisible={setVisible}
        quoteDetail={quoteDetail}
      />
    </>
  );
};

export default QuoteDetail;
